import React, { createContext, useState, useEffect } from 'react'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'
import PortalService from '../../services/PortalVU/PortalVU.service'

export const CurrentPortalContext = createContext()

export const CurrentPortalContextProvider = (props) => {
  const [currentPortal, setCurrentPortal] = useState(null)
  const [portal, setPortal] = useState({
    id: null,
    name: null,
    role: null,
    hasIseeLicence: true,
    hasFlowVULicence: true,
    bucket: null,
    bucketLocation: null
  })
  const [licences, setLicenses] = useState([])

  const handlePortalChange = (portalId) => {
    setCurrentPortal(portalId)
    const cookies = new Cookies()
    cookies.set('lastPortal', portalId, {
      maxAge: 1000 * 60 * 60 * 24 * 365 // 365 days
    })
  }

  const loadPortalCookie = () => {
    const cookies = new Cookies()
    const portal = cookies.get('lastPortal')
    if (portal) {
      setCurrentPortal(portal)
    }
  }

  const fetchLicenses = () => {
    PortalService.fetchLicencesForPortal(portal.id).then((response) => {
      const updatedLicences = response.data.map((licence) => ({
        ...licence,
        usedCount:
          (licence.screens?.length || 0) +
          (licence.devices?.length || 0) +
          (licence.users?.length || 0)
      }))
      setLicenses(updatedLicences)
    })
  }

  const fetchPortalUsers = async () => {
    const res = await PortalService.fetchCurrPortal(portal.name)
    return res.data.users
  }

  useEffect(() => {
    loadPortalCookie()
  }, [])

  useEffect(() => {
    if (portal.name) {
      fetchLicenses()
    }
  }, [portal])

  return (
    <CurrentPortalContext.Provider
      value={{
        handlePortalChange,
        portal,
        setPortal,
        currentPortal,
        fetchLicenses,
        licences,
        fetchPortalUsers
      }}
    >
      {props.children}
    </CurrentPortalContext.Provider>
  )
}

CurrentPortalContextProvider.propTypes = {
  children: PropTypes.object
}
